import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import React, { createRef, useState } from 'react';
import { OpenSheetMusicDisplay } from 'opensheetmusicdisplay';
import { Pitch } from 'opensheetmusicdisplay';
// const path = require('path')
// import XMLData from "flat-test.xml";
// import XMLData from "a-major.xml";
import XMLData from "MozaVeilSample.xml";
// import XMLData from "chromatic-scale.xml";

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Slider from '@mui/material/Slider';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';

import settingsIcon from "./settings-icon.svg";
// import { ReactComponent as SettingsIcon } from "./settings-icon.svg";
import SettingsIcon from '@mui/icons-material/Settings';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';
import MenuIcon from '@mui/icons-material/Menu';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import BorderColorIcon from '@mui/icons-material/BorderColor';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import PrintIcon from '@mui/icons-material/Print';
import TuneIcon from '@mui/icons-material/Tune';
import ErrorIcon from '@mui/icons-material/Error';
import { ReactComponent as MetronomeIcon } from "./29689/metronome.svg";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import PlaybackSettingsPage from "./components/PlaybackSettingsPage.js"
import PrintingPage from "./components/PrintingPage.js"
import SettingsPage from "./components/SettingsPage.js"
import ScoreManagementPage from "./components/ScoreManagementPage.js"
import ScoreProcessingProgressManager from "./components/ScoreProcessingProgressManager.js"
import WelcomePage from "./components/WelcomePage.js"
import AboutPage from "./components/AboutPage.js"
import Keyboard from "./components/Keyboard/Keyboard.js"
import ScoreCreationDialog from "./components/ScoreCreationDialog.js"
import MainBar from "./components/MainBar.js"
import AnnotationCanvas from "./components/AnnotationCanvas.js"
import ScoreMouseControl from "./components/ScoreMouseControl.js"
import OsmdExtension from "./components/OsmdExtension.js"
import ScoreRangeSelector from "./components/ScoreRangeSelector.js"

import settingSystem from "./SettingSystem.js"

import scoreCursorImage from "./cursor.png"
import SheetMusicPlayer from "./components/SheetMusicPlayer.js"
import ScoreDisplayer from "./ScoreDisplayer.js"

import Camera from "./components/Camera.js";

import theme from "./theme.js"
import cbor from 'cbor-js'

import RenderBlocker from './components/RenderBlocker';

import backgroundImage from "./philip-oroni-EaFX0kRvXT8-unsplash.png"
import TextManager from './TextManager';

const NavigationBarResponsiveWidth = "800px";

export default class App extends React.Component {
	state = {
		isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,

		scoreManagePageOpened: false,
		printingPageOpened: false,
		playbackSettingsPageOpened: false,
		aboutPageOpened: false,
		mixerPageOpened: false,
		welcomePageOpened: true,

		scoreCreationDialogOpened: false,

		settingsPageOpened: false,
		navigationMenuOpened: false,
		navigationMenuAnchor: null,

		windowHeight: "100vh",

		showCameraScreen: false,
		fileList: [],

		language: TextManager.language,
	};

	scoreDisplayerRef = React.createRef();
	sheetMusicPlayerRef = React.createRef();
	mainBarRef = React.createRef();
	playbackSettingsPageRef = React.createRef();
	scoreManagementPageRef = React.createRef();
	scoreProcessingProgressManagerRef = React.createRef();
	mergeTracksOption = "fix_disconnected";
	usePreprocessing = true;

	resizeToFitInnerHeight() {
		if (this.state.windowHeight != window.innerHeight) {
			this.setState({ windowHeight: window.innerHeight });
		}
	}

	componentDidMount() {
		const handler = e => {
			// console.log(e.matches);
			this.setState({ isNarrowScreen: e.matches });
		};
		window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).addEventListener('change', handler);

		document.addEventListener('contextmenu', event => event.preventDefault()); // prevent opening context menu

		window.addEventListener('resize', () => {
			this.resizeToFitInnerHeight();

			this.setState({ navigationMenuOpened: false });
		});

		window.onbeforeunload = function (e) {
			e = e || window.event;

			e.preventDefault();

			const message = "Are you to leave? All the progress will be lost." // may not work for most browsers

			// For IE and Firefox prior to version 4
			if (e) {
				e.returnValue = message;
			}

			// For Safari
			return message;
		};


		this.resizeToFitInnerHeight();

		this.sendSampleRequest();

		settingSystem.register("usePreprocessing", () => this.usePreprocessing, (v) => {
			this.usePreprocessing = v;
		});
		settingSystem.register("mergeTracksOption", () => this.mergeTracksOption, (v) => {
			this.mergeTracksOption = v;
		});

		settingSystem.register("language", () => TextManager.language, (v) => {
			TextManager.language = v;
			// this.setState({language: v});
			this.forceUpdate();
		});

	}

	sendSampleRequest = async () => {
		SheetMusicPlayer.singleton.stop();
		this.setState({
			isProcessingRequest: true
		});

		try {
			const res = await axios.post(`/api/sample`, {},
				{
					headers: { 'content-type': 'multipart/form-data' },
					responseType: 'arraybuffer'
				}
			);
			let data = cbor.decode(res.data);
			
			await SheetMusicPlayer.singleton.loadData(data, true);
		} catch (error) {
			//this.setState({ errorMessage: "Failed to load sample score, try again later." })
		} finally {
			this.setState({
				isProcessingRequest: false
			});
		}
	};


	render() {
		// return <Camera/>

		const openPopupPage = (stateName) => {
			// console.log(stateName);
			return new Promise(resolve => {
				this.setState({ [stateName]: true }, resolve);
			})
		}

		const closePopupPage = (stateName) => {
			this.setState({ [stateName]: false });
		}

		const gradient =
			<Box sx={{ maxHeight: 0 }}>
				<svg viewBox="0 0 0 0" width="0" height="0" sx={{ overflow: "hidden" }}>
					<linearGradient id="gradientId" x1={0} y1={0} x2={1} y2={0}>
						<stop offset={0} stopColor="rgba(0,141,254,1)" />
						<stop offset={1} stopColor="rgba(81,202,255,1)" />

					</linearGradient>
				</svg>
			</Box>

		return (
			<ThemeProvider theme={theme}>
				{gradient} {/* for later reference */}
				

				
				<Box className="App" id="App" sx={{
					height: this.state.windowHeight,
					display: "flex",
					flexDirection: "column",
				}}>

					<ScoreDisplayer ref={this.scoreDisplayerRef} sheetMusicPlayerRef={this.sheetMusicPlayerRef} isHidden={this.state.welcomePageOpened}/>
					<SheetMusicPlayer
						ref={this.sheetMusicPlayerRef}
						scoreDisplayerRef={this.scoreDisplayerRef}
						onPlayingStateUpdated={(isPlaying) => { this.mainBarRef.current.setPlayingState(isPlaying) }}
						onUpdateMidiOutputList={() => { this.playbackSettingsPageRef.current?.updateMidiOutputList() }}
						onNonSampleScoreLoaded={()=> {this.setState({welcomePageOpened: false}, ()=>{
							this.sheetMusicPlayerRef.current.setKeyBoardActiveNoteByCursorHover();
						})}}
					// onOsmdLoadedData={this.onOsdmLoaded}
					/>
				

					{this.state.welcomePageOpened? <Box sx={{
						// position: "fixed",
						top: 0,
						left: 0,
						flex: 1,
						width: "100%",
						// height: "100%",
						// bgcolor: "white",
						backgroundImage: "url(" + backgroundImage + ")",
						backgroundSize: "100%",
						display: "flex",
						boxSizing: "border-box",
						

						padding: "0px 10px 0px 10px",
						
						// overflowY: this.state.isNarrowScreen? "scroll" : "hidden",
						overflowY: "scroll",
						// zIndex: 2,
					}}>
						<WelcomePage onGetStartedButtonClicked={() => openPopupPage("scoreCreationDialogOpened")}/>
					</Box>: null}

					<RenderBlocker state={{
						isNarrowScreen: this.state.isNarrowScreen,
						welcomePageOpened: this.state.welcomePageOpened,
						language: TextManager.language,
					}}>
					<MainBar
						ref={this.mainBarRef}
						welcomePageOpened={this.state.welcomePageOpened}
						onClicks={{
							scoreButton: () => openPopupPage("scoreCreationDialogOpened"),
							exportButton: () => {if (this.state.welcomePageOpened) { return; } openPopupPage("printingPageOpened")},
							settingsButton: () => openPopupPage("settingsPageOpened"),
							playbackButton: () => {if (this.state.welcomePageOpened) { return; } openPopupPage("playbackSettingsPageOpened")},
							aboutButton: () => openPopupPage("aboutPageOpened"),
						}}

					/>
					</RenderBlocker>

					{/*<Box height="100px"></Box>*/}

					<Dialog fullScreen={false} maxWidth={false} onClose={() => closePopupPage("scoreCreationDialogOpened")} open={this.state.scoreCreationDialogOpened}>
						<ScoreCreationDialog 
							fileList={this.state.fileList}
						 	close={() => closePopupPage("scoreCreationDialogOpened")} 
						 	setFileList={(fileList) => { this.setState({ fileList: fileList.slice() }) }}
							scoreProcessingProgressManager={this.scoreProcessingProgressManagerRef.current}
							openScoreManagement={async (shouldClearFileList)=>{
								//if(shouldClearFileList){
								await openPopupPage("scoreManagePageOpened")
								//this.scoreManagementPageRef.current.setState({ shouldClearFileList: shouldClearFileList});
								if(shouldClearFileList){
									this.scoreManagementPageRef.current.setState({ list: [] })
								}
								else{
									this.scoreManagementPageRef.current.setState({ list: this.state.fileList.slice() })
								}
								//}
							}}
						 />
					</Dialog>

					<Dialog fullScreen={this.state.isNarrowScreen} maxWidth={false} onClose={() => closePopupPage("playbackSettingsPageOpened")} open={this.state.playbackSettingsPageOpened}>
						<PlaybackSettingsPage ref={this.playbackSettingsPageRef} close={() => closePopupPage("playbackSettingsPageOpened")} />
					</Dialog>

					<Dialog fullScreen={this.state.isNarrowScreen} maxWidth={false} onClose={() => closePopupPage("printingPageOpened")} open={this.state.printingPageOpened}>
						<PrintingPage close={() => closePopupPage("printingPageOpened")} />
					</Dialog>

					<Dialog fullScreen={this.state.isNarrowScreen} maxWidth={false} onClose={() => closePopupPage("aboutPageOpened")} open={this.state.aboutPageOpened}>
						<AboutPage close={() => closePopupPage("aboutPageOpened")} />
					</Dialog>

					<Dialog fullScreen={this.state.isNarrowScreen} maxWidth={false} onClose={() => closePopupPage("scoreManagePageOpened")} open={this.state.scoreManagePageOpened}>
						<ScoreManagementPage
							ref={this.scoreManagementPageRef}
							scoreProcessingProgressManager={this.scoreProcessingProgressManagerRef.current}
							close={() => closePopupPage("scoreManagePageOpened")}
							openCameraScreen={() => { this.setState({ showCameraScreen: true }) }}
							isNarrowScreen={this.state.isNarrowScreen}
							setFileList={(fileList) => { this.setState({ fileList: fileList.slice() }) }}
							fileList={this.state.fileList}
						/>
					</Dialog>

					<Dialog fullScreen={this.state.isNarrowScreen} maxWidth={false} onClose={() => closePopupPage("settingsPageOpened")} open={this.state.settingsPageOpened}>
						<SettingsPage welcomePageOpened={this.state.welcomePageOpened} onZoomChanged={(v) => this.resizeOsmd(v)} close={() => closePopupPage("settingsPageOpened")} />
					</Dialog>

					<Dialog open={this.state.errorMessage != null} >
						<Box sx={{
							margin: "50px 50px",
						}}>
							<Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
								<ErrorIcon />
								<Typography>{this.state.errorMessage}</Typography>
								<Button onClick={() => this.setState({ errorMessage: null })} variant="contained">Close</Button>
							</Stack>
						</Box>
					</Dialog>
				</Box>

				<Dialog fullScreen={true} maxWidth={false} open={this.state.showCameraScreen}>
					<Camera close={() => { this.setState({ showCameraScreen: false }) }} onPhotoCaptured={event => this.scoreManagementPageRef.current.addFile(event.file)} />
				</Dialog>

				<ScoreProcessingProgressManager
					ref={this.scoreProcessingProgressManagerRef}
					welcomePageOpened={this.state.welcomePageOpened}
				/>

			</ThemeProvider>
		);
	}

};